export const normalizeUserRole = (role) => {
	if (!role) return null;

	if (typeof role === 'object' && role.value) {
		return String(role.value).toLowerCase();
	}

	return String(role).toLowerCase();
};

export const mapMeToUserBadge = (me) => {
	if (!me) return null;

	return {
		name: me.name,
		description: `ID: ${me.gorkoId}`,
		imgSrc: me.avatarUrl || undefined,
	};
};

export const mapMeToNavUser = (me) => {
	if (!me) return null;

	return {
		name: me.name,
		description: `ID: ${me.gorkoId}`,
		avatar: me.avatarUrl || undefined,
	};
};
